<script>
import moment from 'moment';

module.exports = {
  template: '#dashboard-template',
  data: function() {
    return {
      anchors: [],
      recommendationsShowAll: false,
      recommendationsHidden: [],
      currentOpen: ['fiksudiiliInfo'],
    };
  },
  methods: {
    showAllRecommendations: function() {
      this.recommendationsShowAll = true;
      while (this.recommendationsHidden.length) {
        this.recommendationsHidden.pop();
      }
      this.$forceUpdate();
    },
    toggleClasses: function(license, current) {
      if (this.currentOpen.indexOf(current) == 0) {
        this.currentOpen.length = 0;
        //pushing a nonsense value to array will properly reset the open class in vue
        this.currentOpen.push('none');
      } else {
        this.currentOpen.length = 0;
        this.currentOpen.push(current);
      }
    },
  },
  computed: {
    logo: function() {
      return '';
    },
    user: function() {
      const user = Object.assign({}, this.$store.state.user);
      user.lastLogin = moment(user.lastLogin).format('DD.MM.YYYY');

      return user;
    },
    phonenumbers: function() {
      let numbersPhone = this.$store.state.brandPhonenumbers ? this.$store.state.brandPhonenumbers : [];
      let car = this.$store.state.cars.active ? this.$store.state.cars.active[0] : false;

      let numbers = [];

      if (car && car.contact_info && car.contact_info.stores.length > 0)
        numbers.push(
          car.contact_info.stores.reduce((result, contact) => {
            if (contact.selected)
              result = {
                name: contact.name,
                phone: contact.phone,
              };

            return result;
          }),
        );

      if (car && car.contact_info && car.contact_info.persons.length > 0)
        numbers.push({
          name: car.contact_info.persons[0].firstname + ' ' + car.contact_info.persons[0].lastname,
          phone: car.contact_info.persons[0].phone,
          small_info: car.brand_name + '-yhteyshenkilösi',
        });

      numbers.push({
        name: 'Laakkonen - kaikki palvelut',
        phone: '+358 10 633 0633',
        open_text: 'Avoinna 7.30 - 17.00',
      });

      if (car) {
        numbers = numbers.concat(
          numbersPhone.reduce((result, item) => {
            if (item.brand == '' || item.brand == car.brand_name) result.push(item);
            return result;
          }, [])
        );
      }
      
      return {
        loading: this.$store.state.brandPhonenumbers ? false : true,
        items: numbers,
      };
    },
    events: function() {
      const lastLogin = this.$store.state.user.lastLogin;
      const stores = this.$store.state.stores;
      let events = this.$store.state.events ? this.$store.state.events : [];
      let now = new Date();
      if (events.length) {
        events = events.map(event => {
          if (event.start == null) event.start = event.created;

          if (typeof event.car === 'undefined' || event.car == null) event.car = false;

        if (event.dealer_id) {
          event.store = stores.find(store => store.dealer_id == event.dealer_id);
        } else {
          event.store = false;
        }

          return event;
        });
      }

      const latestEvents =
        events.length > 0
          ? events.reduce((result, event) => {
              if (+new Date(event.start) >= +now) result.push(event);

              return result;
            }, [])
          : [];

      const oldEvents =
        events.length > 0
          ? events.reduce((result, event) => {
              if (+new Date(event.start) < +now) result.push(event);

              return result;
            }, [])
          : [];

      if (latestEvents.length > 0)
        this.anchors[0] = {
          count: latestEvents.length,
          text: 'tapahtumaa',
          route: { name: 'dashboard-children', params: { section: 'tapahtumat' } },
        };
      else this.anchors[0] = false;

      return {
        count: latestEvents.length,
        latest: latestEvents,
        old: oldEvents,
        loading: this.$store.state.events ? false : true,
        store: this.$store.state.events,
      };
    },
    messages: function() {
      const messages = this.$store.state.messages ? this.$store.state.messages : [];

      let i = 0;
      const latestMessages =
        messages.length > 0
          ? messages.reduce((result, message) => {
              if (!message.isRead && i < 3) result.push(message);
              i++;
              return result;
            }, [])
          : [];

      const oldMessages =
        messages.length > 0
          ? messages.reduce((result, message) => {
              if (message.isRead) result.push(message);

              return result;
            }, [])
          : [];

      if (latestMessages.length > 0)
        this.anchors[1] = {
          count: latestMessages.length,
          text: (latestMessages.length == 1) ? 'viesti' : 'viestiä',
          route: { name: 'dashboard-children', params: { section: 'viestit' } }
        };
      else this.anchors[1] = false;

      return {
        count: latestMessages.length,
        latest: latestMessages,
        old: oldMessages,
        unread: i - latestMessages.length,
        loading: this.$store.state.messages ? false : true,
      };
    },
    cars: function() {
      let cars = this.$store.state.cars;
      let brands = this.$store.state.brands;

      cars.active = cars.active.map(car => {
        if(car.maintenances) {
          car.previous_maintenance_date = car.maintenances.length ? car.maintenances[0].date + 'Z' : '-';
        } else {
          car.maintenances = [];
          car.previous_maintenance_date = '-';
        }

        return car;
      });

      return cars;
    },
    vouchers: function() {
      let vouchers = this.$store.state.vouchers ? this.$store.state.vouchers : [];

      vouchers =
        vouchers.length > 0
          ? vouchers.reduce((result, item) => {
              if (item.value == 0) item.value = false;

              if (item.used == '') result.push(item);

              return result;
            }, [])
          : [];

      if (vouchers.length > 0)
        this.anchors[2] = {
          count: false,
          text: 'useita asiakasetuja',
          route: { name: 'dashboard-children', params: { section: 'asiakasedut' } },
        };
      else this.anchors[2] = false;

      return {
        loading: this.$store.state.vouchers ? false : true,
        items: vouchers,
      };
    },
    recommendations: function() {
      let recommendations = this.$store.state.recommendations ? this.$store.state.recommendations : [];
      let self = this;
      let i = 1;

      if (!self.recommendationsShowAll)
        recommendations = recommendations.map(recommendation => {
          recommendation.id = 'reco-' + i;

          if (i > 4) self.recommendationsHidden.push(recommendation.id);

          i++;
          return recommendation;
        });

      return {
        loading: this.$store.state.recommendations ? false : true,
        items: recommendations,
      };
    },
    articles: function() {
      let articles = this.$store.state.articles ? this.$store.state.articles : [];

      let items = [];

      for (let i = 0; i < articles.length; i++) {
        let category = articles[i];

        items = items.concat(
          category.items.map(article => {
            article.brand = category.brand;
            return article;
          }),
        );
      }

      let ids = [];
      let i = 0;

      items = items.reduce((result, item) => {
        if (ids.indexOf(item.id) < 0 && i < 5 && item.brand) {
          result.push(item);
          ids.push(item.id);
          i++;
        }
        return result;
      }, []);

      items.sort((a, b) => a.date < b.date);

      return {
        items: items,
        loading: this.$store.state.articles ? false : true,
        brands: this.$store.state.brands,
      };
    },
  },
};
</script>